const Loader = () => {
  return (
    <div
      className="h-12 w-12 animate-spin rounded-full p-[1px]"
      style={{
        aspectRatio: "1",
        background: "conic-gradient(#0000 10%, #09864a) content-box",
        WebkitMask: `
          repeating-conic-gradient(#0000 0deg, #000 1deg 20deg, #0000 21deg 36deg),
          radial-gradient(farthest-side, #0000 calc(100% - 8px - 1px), #000 calc(100% - 8px))
        `,
        WebkitMaskComposite: "destination-in",
        maskComposite: "intersect",
      }}
    ></div>
  );
};

export default Loader;
